export enum PaymentProcessor {
    FINVERSE = 'finverse',
    STRIPE   = 'stripe'
}

export function paymentProcessorDisplayName(processor: PaymentProcessor): string {
    switch (processor) {
        case PaymentProcessor.FINVERSE:
            return 'Finverse';
        case PaymentProcessor.STRIPE:
            return 'Stripe';
        default:
            return 'Unknown';
    }
}